import { useRequest } from 'features/request/useRequest';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { checkIsUniqueWorkOrderChangeInternalNumber } from '../WorkOrderChangeQueries';

export const useIsUniqueWorkOrderChangeInternalNumber = ({
    workOrderChangeId,
    newInternalNumber,
    workOrderId,
    isCreating,
}: {
    workOrderChangeId: number;
    newInternalNumber: string;
    workOrderId: number;
    isCreating: boolean;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            number: newInternalNumber,
            workOrderId,
            workOrderChangeId: isCreating ? null : workOrderChangeId,
        }),
        [isCreating, newInternalNumber, workOrderChangeId, workOrderId],
    );

    const [isUniqueData, , , isUniqueRequest] = useRequest({
        requestId: 'useIsUniqueWorkOrderChangeInternalNumber',
        query: checkIsUniqueWorkOrderChangeInternalNumber,
        withEffect: false,
    });

    const debounceCheck = useDebounce(() => {
        if (newInternalNumber) {
            dispatch(isUniqueRequest(variables));
        }
    }, 500);

    useEffect(() => debounceCheck(), [debounceCheck, newInternalNumber]);

    return isUniqueData?.uerIsUniqueWorkOrderChangeInternalNumber?.result ?? true;
};
